import { BrowserProvider, Contract } from "ethers";
import { api } from "@/lib/api";

const ERC20 = ["function allowance(address,address) view returns (uint256)", "function approve(address,uint256) returns (bool)",
  "function balanceOf(address) view returns (uint256)"];
const DESK = ["function buy(uint256 usdtIn, uint256 minFbtcOut) returns (uint256)", "function sell(uint256 fbtcIn, uint256 minUsdtOut) returns (uint256)"];

export const getFbtcPrice = () => api.get("/fbtc/price").then((r) => r.data);
export const getBtcChart = (range) => api.get("/fbtc/chart", { params: { range } }).then((r) => r.data);
export const getFbtcQuote = (side, amount) => api.get("/fbtc/quote", { params: { side, amount } }).then((r) => r.data);

/** Approves (if needed) then buys or sells FBTC on the FBTCDesk at the live BTC rate. */
export async function executeFbtcTrade({ eip1193, quote, tokenIn, onStep }) {
  const signer = await new BrowserProvider(eip1193).getSigner();
  const owner = await signer.getAddress();
  const token = new Contract(tokenIn, ERC20, signer);
  const amountIn = BigInt(quote.amountInRaw);
  if ((await token.balanceOf(owner)) < amountIn) throw new Error(`Insufficient ${quote.side === "buy" ? "USDT" : "FBTC"} balance`);
  if ((await token.allowance(owner, quote.desk)) < amountIn) {
    onStep("Approve in your wallet…");
    await (await token.approve(quote.desk, amountIn)).wait();
  }
  onStep("Confirm the trade in your wallet…");
  const desk = new Contract(quote.desk, DESK, signer);
  const tx = quote.side === "buy" ? await desk.buy(amountIn, BigInt(quote.minOutRaw)) : await desk.sell(amountIn, BigInt(quote.minOutRaw));
  onStep("Settling on FSC…");
  await tx.wait();
  return tx.hash;
}
